import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String,
    legend: Array,
    series: Array,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {},
      index: 0
    };
  },
  watch: {
    series: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.getDataInit();
          } else {
            this.getDataInit();
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },

    /**
     * 获取当前的选中状态
     */
    setSelectStatus: function setSelectStatus(index) {
      var legendSelect = {};

      for (var i in this.legend) {
        if (i == index) {
          legendSelect[this.legend[i]] = true;
        } else {
          legendSelect[this.legend[i]] = false;
        }
      }

      return legendSelect;
    },
    setOption4: function setOption4(index) {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: this.setSelectStatus(index),
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value ? '在线' : '离线';
              result += '<br/>' + params[i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[0].xaxis : []
        },
        yAxis: {
          type: 'value',
          data: ['在线', '离线'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('在线');
              } else if (value === 0) {
                reuslt.push('离线');
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    //紫外线信息
    setOption1: function setOption1(index) {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: this.setOption(index),
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value ? '高温' : '恢复';
              result += '<br/>' + params[i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[1].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          data: ['高温', '恢复'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('高温');
              } else if (value === 0) {
                reuslt.push('恢复');
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    //粘板信息
    setOption2: function setOption2(index) {
      var series = this.series[index];
      var big = [];
      var small = [];

      for (var i in series) {
        var list = series[i];
        big.push(list[0]);
        small.push(list[1]);
      }

      debugger;
      var data = [{
        name: '大飞虫',
        type: 'line',
        key: 3,
        data: big
      }, {
        name: '小飞虫',
        type: 'line',
        key: 3,
        data: small
      }];
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: this.setOption(index),
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var _i in params) {
              var str = params[_i].value;
              result += '<br/>' + params[_i].name + ':电量 ' + str + '%';
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[2].xaxis : []
        },
        yAxis: {
          type: 'value',
          max: 100,
          min: 0,
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: data
      };
      return option;
    },
    //温湿度信息
    setOption3: function setOption3(index) {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: this.setOption(index),
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value;
              result += '<br/>' + params[i].name + ':温湿度 ' + str + '';
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[2].xaxis : []
        },
        yAxis: {
          type: 'value',
          max: 100,
          min: 0,
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: this.series
      };
      return option;
    },
    //维保信息
    setOption: function setOption(index) {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          show: false // data:this.legend,
          // selected:this.setSelectStatus(index),
          // selectedMode:'single'//单选

        },
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params, ticked, callback) {
            var result = params[0].seriesName;

            for (var i in params) {
              var str = params[i].value ? '维保' : '正常';
              result += '<br/>' + params[i].name + ':' + str;
            }

            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[index].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value',
          data: ['维保', '正常'],
          max: 1,
          min: 0,
          axisLabel: {
            formatter: function formatter(value) {
              var reuslt = [];

              if (value === 1) {
                reuslt.push('维保');
              } else if (value === 0) {
                reuslt.push('正常'); // reuslt='正常'
              }

              return reuslt;
            }
          }
        },
        series: this.series
      };
      return option;
    },
    getDataInit: function getDataInit() {
      var index = this.index;
      this.dom.setOption(this.setOption(index));
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.setOption(0));
      this.dom.hideLoading();
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};